<template>
    <div class="product-gallery">

        <!-- FEATURED IMAGE -->
        <div class="product-gallery__featured">
          
            <button @click="handleGalleryZoomBtnClick" type="button" class="product-gallery__zoom">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" class>
                    <path d="M15 18c-2 0-3.8-.6-5.2-1.7-1 1.3-2.1 2.8-3.5 4.6-2.2 2.8-3.4 1.9-3.4 1.9s-.6-.3-1.1-.7c-.4-.4-.7-1-.7-1S.2 19.9 3 17.8c1.8-1.4 3.3-2.5 4.6-3.5C6.6 12.8 6 11 6 9c0-5 4-9 9-9s9 4 9 9-4 9-9 9zm0-16c-3.9 0-7 3.1-7 7s3.1 7 7 7 7-3.1 7-7-3.1-7-7-7zm1 11h-2v-3h-3V8h3V5h2v3h3v2h-3v3z" />
                </svg>
            </button>

            <PhotoSwipe :is-open="isPhotoSwipeOpen"  :items="productImages" :options="photoSwipeOptions" @close="hidePhotoSwipe" @afterChange="handlePhotoSwipeChange"></PhotoSwipe>

            <swiper class="swiper" ref="featuredSwipper" :options="swipperOptions" @slideChange="handleSliderCarouselChange">
                <swiper-slide v-for="(image, index) in productImages" :key="index">
                    <div class="product-image product-image--location--gallery">
                        <a class="product-image__body" @click="handleGalleryZoomBtnClick">
                           <img :src="image.src" :alt="product.name + '_' + index" class="product-image__img">
                        </a>
                    </div>
                </swiper-slide>
                <div class="swiper-pagination" slot="pagination"></div>
            </swiper>


        </div>

        <!-- CARUSEL IMAGE-->
        <div class="product-gallery__carousel">

            <swiper class="swiper" ref="carouselSwipper" :options="swipperOptionsCarusel" @click-slide="handleClickCaruselSlide">
                <swiper-slide v-for="(image, index) in productImages" :key="index">
                    <a :class="[{'product-gallery__carousel-item': true, 'product-image': true, 'product-gallery__carousel-item--active': index == swipperCaruselActiveIndex }]">
                        <span class="product-image__body"><img :src="image.src" alt="" class="product-image__img product-gallery__carousel-image"></span>
                    </a>
                </swiper-slide>
                <div class="swiper-pagination-2" slot="pagination"></div>
            </swiper>

        </div>
    </div>

</template>

<script>
    import Swipe from '@/common/vendor/swipe';
    import { mapState } from 'vuex'
    import { PhotoSwipe } from 'v-photoswipe';
    import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper';

    export default {
        swipe: null,
        components: { Swiper, SwiperSlide, PhotoSwipe },
        directives: {
            swiper: directive
        },
        mounted(){
          // setTimeout(function() {    // Wait for js empty stack
          //   const galleryLinks = document.querySelectorAll('.pswp__img');    // Get all links
          //   galleryLinks.forEach((element) => {
          //     let image = new Image();
          //     image.src = element.getAttribute('href');
          //     image.onload = () => {    // Wait for image to load
          //       element.setAttribute('data-size', `${image.naturalWidth}x${image.naturalHeight}`);
          //       image = null;    // Free resource so garbage collector can clean it
          //     }
          //
          //   });
          // }, 1);
        },
        computed: {
            ...mapState('pageModule', {
                product: 'pageModel'
            }),
            productImages() {

              let images = [];
              
                if (this.product.thumbnail != null && this.product.thumbnail.path) {
                  images = [{ src:  this.product.thumbnail.path, w: window.innerWidth, h: window.innerHeight }]
                }
                
                if (this.product.productImages != null && this.product.productImages.length > 0) {
                  images = [...images, ...this.product.productImages.map(x=> { return {src: x.path, w: window.innerWidth, h: window.innerHeight}})]
                }
                if(images.length > 0){
                  return images;
                }
                
                return [{ src:  "/images/no-image-found.png", w: 600, h: 600 }]
            }
        },
        data() {
            return {
                swipperOptions: {
                  slidesPerView: 1,
                    pagination: {
                        el: '.swiper-pagination'
                    },
                },
                swipperOptionsCarusel: {
                    slidesPerView: 5,
                    spaceBetween: 10,
                    pagination: {
                        el: '.swiper-pagination-2',
                        clickable: true
                    }
                },
                photoSwipeOptions: {
                    bgOpacity: 0.7,
                    showHideOpacity: true,
                    showAnimationDuration: 500,
                    index: 0
                },
                swipperCaruselActiveIndex: 0,
                isPhotoSwipeOpen: false
            }
        },
        methods: {
            showPhotoSwipe(index) {
                this.isPhotoSwipeOpen = true
                this.$set(this.photoSwipeOptions, 'index', index)
            },
            hidePhotoSwipe() {
                this.isPhotoSwipeOpen = false
            },
            handlePhotoSwipeChange(photoSwipe) {
                let currentIndex = photoSwipe[0].pswp.getCurrentIndex() || 0;
                this.$refs.featuredSwipper.$swiper.slideTo(currentIndex, 500, false);
                this.swipperCaruselActiveIndex = currentIndex;
            },
            handleGalleryZoomBtnClick() {
                this.showPhotoSwipe(this.swipperCaruselActiveIndex);
            },
            handleClickCaruselSlide(index, reallyIndex) {
                this.$refs.featuredSwipper.$swiper.slideTo(index, 500, false);
                this.swipperCaruselActiveIndex = index;
            },
            handleSliderCarouselChange(index) {
                this.swipperCaruselActiveIndex = this.$refs.featuredSwipper.$swiper.activeIndex;
            },
        }
    }
</script>

<style lang="scss">
.pswp img {
  max-width: none;
  object-fit: contain;
}
</style>